"use client";

import { useEffect } from "react";

interface ThemeInjectorProps {
  themeCSS: string;
}

export default function ThemeInjector({ themeCSS }: ThemeInjectorProps) {
  useEffect(() => {
    // Remove existing theme style if present
    const existingStyle = document.getElementById("theme-css");
    if (existingStyle) {
      existingStyle.remove();
    }

    // Inject new theme CSS into head
    if (themeCSS) {
      const styleElement = document.createElement("style");
      styleElement.id = "theme-css";
      styleElement.textContent = themeCSS;
      document.head.appendChild(styleElement);
    }

    return () => {
      // Cleanup on unmount
      const style = document.getElementById("theme-css");
      if (style) {
        style.remove();
      }
    };
  }, [themeCSS]);

  return null; // This component doesn't render anything
}
